import React from 'react';
import { MessageCircle } from 'lucide-react';
import { doctorInfo } from '../mockData';

const WhatsAppButton = () => {
  const whatsappUrl = `https://wa.me/${doctorInfo.whatsapp}?text=Hello%20Dr.%20Akshay%20Kawedia,%20I%20would%20like%20to%20book%20a%20consultation.`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-3 rounded-full shadow-lg transition-all hover:scale-105 group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden group-hover:inline-block transition-all font-medium">
        Chat with us
      </span>
    </a>
  );
};

export default WhatsAppButton;
